/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { ApplicationRef, Component, OnInit } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { Platform } from '@ionic/angular/standalone';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { interval } from 'rxjs';
import { filter, first, map, switchMap, tap } from 'rxjs/operators';
import { ToastModule } from 'primeng/toast';

import { StorageService } from './core/services/storage.service';
import { UserService } from './core/services/user.service';
import { AnalyticsService } from './core/services/analytics.service';
import { ThemeService } from './core/services/theme.service';
import { RouterOutlet } from '@angular/router';
import { ConfirmDialog } from 'primeng/confirmdialog';


declare let window: Window;

@Component({
  imports: [IonApp, IonRouterOutlet, ToastModule, RouterOutlet, ConfirmDialog],
  selector: 'app-root',
  standalone: true,
  templateUrl: 'app.component.html',
})
export class AppComponent implements OnInit {
  constructor(
    private readonly appRef: ApplicationRef,
    private readonly storage: StorageService,
    private readonly swUpdate: SwUpdate,
    private readonly platform: Platform,
    private readonly user: UserService,
    private readonly analyticsService: AnalyticsService,
    private readonly themeService: ThemeService,
  ) {}

  ngOnInit(): void {
    // генерим UUID для пушей
    // todo: переделать на использование generateUUID из helper
    const generateUUID = () => {
      this.user.data.uuid = this.user.generateUUID();
      this.user.saveUserData();
    };

    this.storage.get('userData').then((val) => {
      if (val != null) {
        if (val.settings) {
          this.user.data.settings.globalSettings = {
            ...this.user.data.settings.globalSettings,
            ...val.settings.globalSettings,
          };
          this.user.data.settings.appSettings = {
            ...this.user.data.settings.appSettings,
            ...val.settings.appSettings,
          };
          // преобразовываем под новый формат справочника групп ПВЗ
          if (this.user.data.settings.appSettings.selected_group?.title) {
            this.user.data.settings.appSettings.selected_group.name = this.user.data.settings.appSettings.selected_group.title;
            delete this.user.data.settings.appSettings.selected_group.title;
          }
          this.user.data.settings.pvzsSettings = {
            ...this.user.data.settings.pvzsSettings,
            ...val.settings.pvzsSettings,
          };
          this.user.data.settings.requestsSettings = {
            ...this.user.data.settings.requestsSettings,
            ...val.settings.requestsSettings,
          };
          this.user.data.settings.shiftsSettings = {
            ...this.user.data.settings.shiftsSettings,
            ...val.settings.shiftsSettings,
          };
          this.user.data.settings.statsSettings = {
            ...this.user.data.settings.statsSettings,
            ...val.settings.statsSettings,
          };
          this.user.data.settings.usersSettings = {
            ...this.user.data.settings.usersSettings,
            ...val.settings.usersSettings,
          };
          delete val.settings;
        }
        this.user.data = { ...this.user.data, ...val };
        if (!this.user.data.uuid) generateUUID();
      } else {
        generateUUID();
      }

      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');
      const toggleDarkTheme = (shouldAdd: boolean) => {
        document.body.classList.toggle('dark', shouldAdd);
        if (shouldAdd) {
          this.user.data.settings.appSettings.dark_theme = true;
        }
        this.themeService.setDarkTheme(shouldAdd);
      };
      prefersDark.addListener((mediaQuery) => toggleDarkTheme(mediaQuery.matches));
      toggleDarkTheme(Boolean(this.user.data.settings.appSettings.dark_theme));

      this.analyticsService.ymInitialize();
      if (this.user.data.id) {
        this.analyticsService.phIdentify()
      }
    });

    // чекаем обновление версии приложения
    if (this.swUpdate.isEnabled) {
      try {
        this.swUpdate.versionUpdates
          .pipe(
            filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'),
            map((evt) => ({
              available: evt.latestVersion,
              current: evt.currentVersion,
              type: 'UPDATE_AVAILABLE',
            })),
          )
          .subscribe(() => this.swUpdate.activateUpdate().then(() => window.location.reload()));
      } catch (e) {
        this.analyticsService.phCaputeException(e, { 'Источник': 'Проверка обновления при запуске' });
        //console.log('service worker disabled', e);
      }

      this.appRef.isStable
        .pipe(
          first((stable) => stable),
          tap(() => {
            /* console.log('App is stable now'); */ this.swUpdate.checkForUpdate();
          }),
          switchMap(() => interval(3 * 60 * 1000)),
        )
        .subscribe(() => {
          try {
            this.swUpdate.checkForUpdate();
          } catch (e) {
            //console.log('service worker disabled', e);
            this.analyticsService.phCaputeException(e, { 'Источник': 'Периодическая проверка обновления' });
          }
        });
    }

    // адаптация под клавиатуру
    // todo: сделать адаптацию под клавиатуру для digit keyboard IOS
    // this.platform.keyboardDidShow.subscribe((e) => {
    //   const { keyboardHeight } = e;
    //   const app = document.querySelector('ion-app');
    //   if (app) app.style.setProperty('bottom', `${keyboardHeight}px`);
    // });

    // this.platform.keyboardDidHide.subscribe(() => {
    //   const app = document.querySelector('ion-app');
    //   if (app) app.style.removeProperty('bottom');
    // });
  }
}
